import { Component } from '@angular/core';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

@Component({
  standalone: true,
  imports: [EditProfileComponent, ChangePasswordComponent],
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss', '../../app.component.scss']
})
export class MyProfileComponent { 

}
